export default{
    equityResults: true,
    refChangesFlag: true,
    ready: false,
    loading: false,
    loggedIn: false,
    loggedOut: false,
    accessGranted: true,
    sidebarWidth: 200,
    query_request_delay: 5000,
    selectedInstrumentName: '',
    selectedQuotePermId: '',
    selectedIssuePermId: '',
    selectedRIC: '',
    equityColumns: [
        {'title': 'Instrument', 'field': 'int_ric', 'sortBy': 'int_ric', 'minWidth': 100},
        {'title': 'Security Description', 'field': 'int_security_description', 'sortBy': 'int_security_description', 'minWidth': 150, contentWrap: true},
        {'title': 'Company Short Name', 'field': 'int_company_short_name', 'sortBy': 'int_company_short_name', 'minWidth': 150},
        {'title': 'Asset Status', 'field': 'int_asset_status', 'sortBy': 'int_asset_status', 'minWidth': 100},
        {'title': 'Currency Code', 'field': 'int_currency_code', 'sortBy': 'int_currency_code', 'minWidth': 150},
        {'title': 'CUSIP', 'field': 'int_cusip', 'sortBy': 'int_cusip', 'minWidth': 100},
        {'title': 'ISIN', 'field': 'int_isin', 'sortBy': 'int_isin', 'minWidth': 100},
        {'title': 'SEDOL', 'field': 'int_sedol', 'sortBy': 'int_sedol', 'minWidth': 100},
        {'title': 'Refinitiv Classification Scheme', 'field': 'int_trbc_industry_code', 'sortBy': 'int_trbc_industry_code', 'width': 250, contentWrap: true},
        {'title': 'Share Class', 'field': 'int_share_class', 'sortBy': 'int_share_class', 'minWidth': 100},
        {'title': 'Quote Perm Id', 'field': 'int_quote_perm_id', 'sortBy': 'int_quote_perm_id', 'minWidth': 120},
        {'title': 'Issue Perm Id', 'field': 'int_issue_perm_id', 'sortBy': 'int_issue_perm_id', 'minWidth': 120}
    ],
    equityData: [],
    refFieldsFlag: false,
    refFieldsData: [],
    refFieldsArray: {},
    refChangesData: [],
    equityReferenceChangeColumns: [
        {'title': 'Publish Date', 'field': 'publishedDate', 'sortBy': 'publishDate', 'width': 150},
        {'title': 'Segment', 'field': 'publishSegment', 'sortBy': 'publishSegment', 'width': 100},
        {'title': 'Action', 'field': 'action', 'sortBy': 'action', 'width': 150},
        {'title': 'Field', 'field': 'field', 'sortBy': 'field', 'minWidth': 250},
        {'title': 'Previous', 'field': 'previous', 'minWidth': 250},
        {'title': 'Current', 'field': 'current', 'minWidth': 250}
    ],
    equityPricingColumns: [
        {'title': 'Trade Date', 'field': 'timestamp', 'sortBy': 'timestamp', 'width': 200},
        {'title': 'Ask', 'field': 'askPrice', 'sortBy': 'askPrice', 'minWidth': 100},
        {'title': 'Bid', 'field': 'bidPrice', 'sortBy': 'bidPrice', 'minWidth': 100},
        {'title': 'Open', 'field': 'openPrice', 'sortBy': 'openPrice', 'minWidth': 100},
        {'title': 'High', 'field': 'highPrice', 'sortBy': 'highPrice', 'minWidth': 100},
        {'title': 'Low', 'field': 'lowPrice', 'sortBy': 'lowPrice', 'minWidth': 100},
        {'title': 'Close', 'field': 'closePrice', 'sortBy': 'closePrice', 'minWidth': 100},
        {'title': 'Volume', 'field': 'volume', 'sortBy': 'volume', 'minWidth': 100}
    ],
    pricingData: [],
    exPricingData: [],
    equityCorporateActionsReferenceEventColumns: [
        {'title': 'Event', 'field': 'xri_event_id', 'sortBy': 'xri_event_id', 'minWidth': 120},
        {'title': 'Type', 'field': 'xri_type', 'sortBy': 'xri_type', 'minWidth': 120},
        {'title': 'Last Update Date', 'field': 'xri_last_update_date', 'sortBy': 'xri_last_update_date', 'minWidth': 120},
    ],
    equityCorporateActionsEventColumns: [
        {'title': 'Adjusted Declared Dividend Amount', 'field': 'xdi_adjusted_declared_dividend_amount', 'sortBy': 'xdi_adjusted_declared_dividend_amount', 'minWidth': 150, 'alignment': 'right'},
        {'title': 'Declared Dividend Amount', 'field': 'xdi_declared_dividend_amount', 'sortBy': 'xdi_declared_dividend_amount', 'minWidth': 150, 'alignment': 'right'},
        {'title': 'Payment Frequency', 'field': 'xdi_payment_frequency', 'sortBy': 'xdi_payment_frequency', 'minWidth': 120},
        {'title': 'Record Date', 'field': 'xdi_record_date', 'sortBy': 'xdi_record_date', 'width': 120, contentWrap: true},
        {'title': 'Distribution Marker Type Code', 'field': 'xdi_distribution_marker_type_code', 'sortBy': 'xdi_distribution_marker_type_code', 'minWidth': 150},
        {'title': 'Source of Funds Code', 'field': 'xdi_source_of_funds_code', 'sortBy': 'xdi_source_of_funds_code', 'minWidth': 150},
        {'title': 'Payment Date', 'field': 'xdi_payment_date', 'sortBy': 'xdi_payment_date', 'width': 120, contentWrap: true},
        {'title': 'Reinvestment Price', 'field': 'xdi_reinvestment_price', 'sortBy': 'xdi_reinvestment_price', 'minWidth': 120, 'alignment': 'right'},
        {'title': 'Event Id', 'field': 'xdi_event_id', 'sortBy': 'xdi_event_id', 'width': 120},
        {'title': 'Announcement Date', 'field': 'xdi_announcement_date', 'sortBy': 'xdi_announcement_date', 'width': 120, contentWrap: true},
        {'title': 'Effective Date', 'field': 'xdi_effective_date', 'sortBy': 'xdi_effective_date', 'width': 120, contentWrap: true},
        {'title': 'Ex Date', 'field': 'xdi_ex_date', 'sortBy': 'xdi_ex_date', 'width': 120, contentWrap: true},
        {'title': 'Payment Date', 'field': 'xdi_payment_date', 'sortBy': 'xdi_payment_date', 'width': 120, contentWrap: true},
        {'title': 'Existing Securities Quantity', 'field': 'xdi_existing_securities_quantity', 'sortBy': 'xdi_existing_securities_quantity', 'minWidth': 140, 'alignment': 'right'},
        {'title': 'Additional Information 1', 'field': 'xdi_additional_information_1', 'sortBy': 'xdi_additional_information_1', 'minWidth': 200, contentWrap: true},
        {'title': 'Additional Information 2', 'field': 'xdi_additional_information_2', 'sortBy': 'xdi_additional_information_2', 'minWidth': 200, contentWrap: true},
        {'title': 'Event Action Code', 'field': 'xdi_event_action_code', 'sortBy': 'xdi_event_action_code', 'minWidth': 120},
        {'title': 'Processing Status', 'field': 'xdi_processing_status', 'sortBy': 'xdi_processing_status', 'minWidth': 140},
        {'title': 'Processing Type Code', 'field': 'xdi_processing_type_code', 'sortBy': 'xdi_processing_type_code', 'minWidth': 120},
        {'title': 'Record Date', 'field': 'xdi_record_date', 'sortBy': 'xdi_record_date', 'width': 120, contentWrap: true},
        {'title': 'Rescinded Date', 'field': 'xdi_rescinded_date', 'sortBy': 'xdi_rescinded_date', 'width': 120, contentWrap: true},
        {'title': 'Type', 'field': 'xdi_type', 'sortBy': 'xdi_type', 'minWidth': 100},
    ],
    referenceActive: true,
    corporateActionsActive: false,
    pricingActive: false,
    corporateActionsReferenceActive: true,
    corporateActionsEventsActive: false,
    equityReferenceFields: [],
    sampleEquityReferenceChanges: [],
    equityCorporateActionsReferenceQueryResult: [],
    equityCorporateActionsReferenceFieldChangesQueryResult: [],
    equityCorporateActionsReferenceEventFields: [],
    equityCorporateActionsReferenceFields: [],
    equityCorporateActionsReferenceFieldChanges: [],
    highlightEquityCorporateActionsReferenceFieldChanges: [],
    sampleEquityCorporateActionsReferenceChanges: [],
    equityReferenceChangesItems : [],
    equityCorporateActionsEventFields: [],
    equityCorporateActionsEventItems: [],
    sampleEquityCorporateActionsEventChanges: [],
    dateFormat: 'D MMM YYYY',
    selectedDate: '2023-05-13',
    todayDate: '2023-05-13',
    maxDate: '2025-02-08',
    minDate: '2025-01-11',
    markets: [
        { label: 'Hong Kong', value: 'HK' },
        { label: 'Japan', value: 'JP' },
        { label: 'Singapore', value: 'SG' },
        { label: 'Thailand', value: 'TH' },
        { label: 'USA', value: 'US' },
        { label: 'Australia', value: 'AU' },
        { label: 'Canada', value: 'CA' },
        { label: 'France', value: 'FR' },
        { label: 'Germany', value: 'GE' },
        { label: 'Indonesia', value: 'IN' },
        { label: 'London', value: 'LN' },
        { label: 'Philippines', value: 'PH' },
        { label: 'Switzerland', value: 'SW' },
        { label: 'Netherlands', value: 'NL' },
        { label: 'India', value: 'IND'},
        { label: 'Kuala Lumpur Stock Exchange', value: 'KLS' },
        { label: 'New York Stock Exchange', value: 'NYS' },
        { label: 'NASDAQ Stock Exchange Capital Market', value: 'NAS' },
        { label: 'NASDAQ Stock Exchange Global Market', value: 'NMS' },
        { label: 'NASDAQ National Market System', value: 'NMQ' },
        { label: 'American Stock Exchange', value: 'ASE' },
        { label: 'Singapore Exchange Securities Trading', value: 'SES' },
        { label: 'The Stock Exchange of Hong Kong Ltd', value: 'HKG' },
        { label: 'Australian Stock Exchange Ltd', value: 'ASX' },
        { label: 'The Toronto Stock Exchange', value: 'TOR' },
        { label: 'Paris Stock Exchange', value: 'PAR' },
        { label: 'Euronext Access Paris', value: 'EMA' },
        { label: 'Xetra', value: 'GER' },
        { label: 'Indonesia Stock Exchange (formerly Jakarta SE)', value: 'JKT' },
        { label: 'The Stock Exchange of Thailand', value: 'SET' },
        { label: 'Tokyo Stock Exchange', value: 'TYO' },
        { label: 'Fukuoka Stock Exchange', value: 'FKA' },
        { label: 'Nagoya Stock Exchange', value: 'NGO' },
        { label: 'Sapporo Securities Exchange', value: 'SAP' },
        { label: 'London Stock Exchange', value: 'LSE' },
        { label: 'Philippine Stock Exchange Inc', value: 'PHS' },
        { label: 'Swiss Exchange', value: 'SWX' },
        { label: 'Euronext Amsterdam', value: 'AEX' },
        { label: 'Frankfurt Stock Exchange', value: 'FRA' }
    ],
    criteria: [
        { label: "RIC", value: "ric" },
        { label: "ISIN", value: "isin" },
        { label: "CUSIP", value: "cusip" },
        { label: "SEDOL", value: "sedol" }
    ],
    selectedMarket: '',
    highlightColor: '#001EFF',
    fontColor: '#FFFFFF',
    appName: 'dsp-tool',
    jwt: "",
    currentUser: "",
    requestType: "",
    rowClickFlag: [0, 0, 0, 0, 0],
    priceChartFlag: false,
    promiseFlag: 0,
    refPromise: 0,
    exportInstruments: [],
    exportRefData: [],
    exportCoraxRefData: [],
    exportCoraxEventsData: [],
    exportQuotes: [],
    exportIssues: [],
    iRPMenv: process.env.VUE_APP_IRPM_ENV
}